module.exports = __webpack_public_path__ + "images/emoji/arrow_heading_up.e2c2d3ecbfa8649b7f9b.png";